module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="snippet-open';
 if ( hasRipple ) { 
__p+=' has-ripple primary-ripple ';
 } 
__p+=' '+
((__t=( iconClass ))==null?'':__t)+
'" data-click="snippet-open" '+
((__t=( attributes ))==null?'':__t)+
'><span class="snippet-title">'+
((__t=( header ))==null?'':__t)+
'</span></a><a href="#" class="icon icon-material icon-expand snippet-expand" data-toggle="expand-spoiler" '+
((__t=( canExpand ? "" : " hidden" ))==null?'':__t)+
'><span class="screen-reader-text">'+
((__t=( i18n.tc("SupportResponseSnippet", "Expand") ))==null?'':__t)+
'</span></a><div class="expand-spoiler" data-container="expand-spoiler"><div data-region="snippet-functionality"></div><h6 class="related-title tight" hidden><small>'+
((__t=( i18n.tc( "SupportResponseSnippet", "Related objects" ) ))==null?'':__t)+
'</small></h6><div class="snippet-container" data-region="snippet-container"></div></div>';
}
return __p;
};
